import React, { useContext, useState, useRef, useEffect } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Moment from "react-moment";
import { useReactToPrint } from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import { MdDelete } from 'react-icons/md';
// import StockReport from "./StockReport";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const BalanceSheetReport = () => {
    const { t } = useTranslation();
    let {loading, setLoading, generalSettings } = useContext(SettingsContext);
    const { branchForSearch } = useContext(RestaurantContext);
    const { authUserInfo } = useContext(UserContext);
    
    //toast obj
    let common_toast={
      position: "bottom-center",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    }

    //reportFields state
    const [option,setOption] = useState("print");
    const [balanceSheetView, setBalanceSheetView] = useState(null);
    const [searchBalanceSheetView, setSearchBalanceSheetView] = useState({
      searched: false,
      list: [],
    });
    const [reportFields,setReportFields]=useState({
      from_date:"",
      to_date:"",
      branch: "",
    });

    const [siteName, setSiteName] = useState("");
    const isThrottled = useRef(false);
    //report states
    const [reportData, setReportData] = useState([]);
    const [generatedReport, setGeneratedReport] = useState(false);

    const componentRef = useRef();
    const componentRefThermal = useRef();

    useEffect(() => {
      setSiteName(getSystemSettings(generalSettings, "siteName"));
    },[generalSettings]);

    //search account here
    // const handleSearch = (e) => {
    //   let searchInput = e.target.value.toLowerCase();
    //   if (searchInput.length === 0) {
    //     setBalanceSheetView({ ...searchBalanceSheetView, searched: false });
    //   } else {
    //     let searchedList = balanceSheetView?.data && balanceSheetView.data.filter((item) => {          
    //       let lowerCaseItemIdentity = item.DocumentIdentity && item.DocumentIdentity.toLowerCase();
    //       let lowerCaseItemAccount = item.AccountName.toLowerCase();
    //       let lowerCaseItemCheque = item.ChequeNo && item.ChequeNo.toLowerCase();
    //       return (lowerCaseItemIdentity && lowerCaseItemIdentity.includes(searchInput)) ||
    //       (lowerCaseItemAccount && lowerCaseItemAccount.includes(searchInput)) ||
    //       (lowerCaseItemCheque && lowerCaseItemCheque.includes(searchInput));
    //     });
    //     setSearchBalanceSheetView({
    //       list: searchBalanceSheetView,
    //       searched: true,
    //     });
    //   }
    // };

    // const handleFromDate=(from_date)=>{
    //   setReportFields({
    //     ...reportFields,
    //     from_date
    //   })
    // }

    const handleToDate=(to_date)=>{
      setReportFields({
        ...reportFields,
        to_date
      })
    }

    const handleOption=(e)=>{
      setOption(e.target.value);
    }

    const handleBranch=(branch)=>{
      setReportFields({
        ...reportFields,
        branch
      })
    }

    const paginatedBalanceSheet = (page)=>{
      if (isThrottled.current) {
        return;
      }
      isThrottled.current = true;
      setTimeout(() => {
        isThrottled.current = false;
      }, 3000);
      const url = BASE_URL + "/settings/get-balance-sheet-report?=page="+page;
      let {to_date, branch } = reportFields
      let formData = new FormData();
      // formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
      formData.append('to_date', moment(to_date).format("YYYY-MM-DD"));
      formData.append('branch_id', branch ? branch.id : "");
      return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setBalanceSheetView(res.data);
        setLoading(false);
      })
      .catch((error) => {            
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`,common_toast);
      });
    }

    const thermalPrint = useReactToPrint({
      content: () => componentRefThermal.current,
      pageStyle: `@page { margin: 10px 15px; }`,
    });

    const handleSubmit=(e)=>{
      e.preventDefault();
      setBalanceSheetView(null);
      setSearchBalanceSheetView(null);
      let {to_date, branch } = reportFields;
      if (
        (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
        !branch?.id
      ) {
        toast.error(`${_t(t("Please select branch"))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
      if(
        // (from_date !== "" && from_date !== null) && 
        (to_date !== "" && to_date !== null)){
        // setLoading(true);
        if(option === "view"){
          paginatedBalanceSheet(1);
        }else{
          const url = BASE_URL + "/settings/get-balance-sheet-report";
          let formData = new FormData();
          // formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
          formData.append('to_date', moment(to_date).format("YYYY-MM-DD"));
          formData.append('branch_id', branch ? branch.id : "");
          return axios
          .post(url, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setReportData(res.data);
            if(option === "print"){
              thermalPrint();
            }else{
              setGeneratedReport(true);
              componentRef.current.handleDownload();
            }
            setLoading(false);
          })
          .catch((error) => {            
            setLoading(false);
            toast.error(`${_t(t("Please try again"))}`,common_toast);
          });

        }
      }else{
        toast.error(`${_t(t("Please select date"))}`,common_toast);
      }
    }

    let assetsTotal = 0;
    let liabilitiesTotal = 0;
    let assetsTotalPrint = 0;
    let liabilitiesTotalPrint = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("Accounts Balance Sheet Report"))}</title>
      </Helmet>

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Accounts Balance Sheet Report"
        sheet="sheet 1"
        buttonText="Report"
        ref={componentRef}
      />

      {/* Print Button */}
      <div className="d-none">
        <div className="fk-print">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {
                reportData !== null &&
                  reportData !== undefined &&
                  generatedReport === true && 
                  (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls"
                          >
                            <div className="page-break"></div>
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan="3" style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {siteName}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Accounts Balance Sheet Report
                                      </h3>
                                        <p className="text-center">
                                          &nbsp;Till Date&nbsp;
                                          <Moment format="LL">{reportFields.to_date}</Moment>
                                        </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Account Type"))}
                                </th>
                                
                                <th
                                  scope="col"
                                >
                                  {_t(t("Account Name"))}
                                </th>
                                
                                <th
                                  scope="col"
                                >
                                  {_t(t("Amount"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here*/}
                              {
                                reportData && reportData[0] && Object.keys(reportData[0]).map((group)=>{
                                  let asset= 0;
                                  return(
                                    <>
                                      <tr>
                                        <th>{group}</th>
                                      </tr>
                                      {
                                        reportData[0][group] && reportData[0][group].map((item, index)=>{
                                          assetsTotalPrint += Number(item?.balance) || 0;
                                          asset += Number(item?.balance) || 0;
                                          return(
                                            <tr key={index}>
                                              <td></td>
                                              <td>{item?.AccountName || ''}</td>
                                              <td>{item?.balance < 0 ? `(${formatPrice(item?.balance * -1)})` : formatPrice(item?.balance) || ''}</td>
                                            </tr>
                                          )
                                      })}
                                      <tr>
                                        <td></td>
                                        <th>Total</th>
                                        <td><strong>{asset < 0 ? `(${formatPrice(asset * -1)})` : formatPrice(asset)}</strong></td>
                                      </tr>
                                    </>
                                  )
                                })
                              }
                              <tr></tr>
                              <tr>
                                <th colSpan={2}>Assets Total</th>
                                <th>{assetsTotalPrint < 0 ? `(${formatPrice(assetsTotalPrint * -1)})` : formatPrice(assetsTotalPrint)}</th>
                              </tr> 

                              <tr></tr>

                              {
                                reportData && reportData[1] && Object.keys(reportData[1]).map((group)=>{
                                  let liability = 0;
                                  return(
                                    <>
                                      <tr>
                                        <th>{group}</th>
                                      </tr>
                                      {
                                        reportData[1][group] && reportData[1][group].map((item, index)=>{
                                          liabilitiesTotalPrint += Number(item?.balance) || 0;
                                          liability += Number(item?.balance) || 0;
                                          return(
                                            <tr key={index}>
                                              <td></td>
                                              <td>{item?.AccountName || ''}</td>
                                              <td>{item?.balance < 0 ? `(${formatPrice(item?.balance * -1)})` : formatPrice(item?.balance) || ''}</td>
                                            </tr>
                                          )
                                      })}
                                      <tr>
                                        <td></td>
                                        <th>Total</th>
                                        <td><strong>{liability < 0 ? `(${formatPrice(liability * -1)})` : formatPrice(liability)}</strong></td>
                                      </tr>
                                    </>
                                  )
                                })
                              }
                              <tr></tr>
                              <tr>
                                <th colSpan={2}>Liabilities & Equity Total</th>
                                <th>{liabilitiesTotalPrint < 0 ? `(${formatPrice(liabilitiesTotalPrint * -1)})` : formatPrice(liabilitiesTotalPrint)}</th>
                              </tr> 

                              {/* {reportData && reportData[0] &&
                                Array.from({ length: Math.max(reportData[0]?.length || 0, reportData[1]?.length || 0) }).map((_, index) => {
                                  const itemA = reportData?.[0]?.[index];
                                  const itemB = reportData?.[1]?.[index];
                                  assetsTotalPrint += Number(itemA?.balance) || 0;
                                  liabilitiesTotalPrint += Number(itemB?.balance) || 0;
                                  return(
                                    <tr>
                                      {
                                        itemA && (
                                          <>
                                            <td>{itemA ? index + 1 : ''}</td>
                                            <td>{itemA?.AccountName || ''}</td>
                                            <td>{itemA?.balance < 0 ? `(${itemA?.balance * -1})` : itemA?.balance || ''}</td>
                                          </>
                                        )
                                      }
                                      {
                                        itemB && (
                                          <>
                                            <td>{itemB ? index + 1 : ''}</td>
                                            <td>{itemB?.AccountName || ''}</td>
                                            <td>{itemB?.balance < 0 ? `(${itemB?.balance * -1})` : itemB?.balance || ''}</td>
                                          </>
                                        )
                                      }
                                    </tr>
                                  )}
                                )
                              }
                              <tr>
                                <th colSpan={2}>Assets Total</th>
                                <th>{assetsTotalPrint < 0 ? `(${assetsTotalPrint * -1})` : assetsTotalPrint}</th>
                                <th colSpan={2}>Liabilities Total</th>
                                <th>{liabilitiesTotalPrint < 0 ? `(${liabilitiesTotalPrint * -1})` : liabilitiesTotalPrint}</th>
                              </tr> */}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* thermal print */}
      <div className="d-none">
        <div ref={componentRefThermal}>
          {          
            <div className="fk-print">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    {reportData !== null &&
                      reportData !== undefined && (
                      <table className="table table-bordered mt-4 fk-print-text_pos">
                        <thead className="align-middle sm-text">
                          <tr style={{ border: "0px" }}>
                            <th colspan="3" style={{ border: "0px" }}>
                              <div className="row">
                                <h3 className="text-center mb-0">
                                  {siteName}
                                </h3>
                                <h3 className="mt-2 font-weight-bold text-uppercase text-center table-text">
                                  Accounts Balance Sheet Report
                                </h3>
                                <div>
                                  <p className="mt-1 mb-0 font-weight-bold text-uppercase text-center table-text">
                                    {/* FROM&nbsp;
                                    <Moment format="LL">
                                    {reportFields.from_date}
                                    </Moment> */}
                                    &nbsp;Till Date&nbsp;
                                    <Moment format="LL">{reportFields.to_date}</Moment>
                                  </p>
                                </div>
                              </div> 
                            </th>
                          </tr>  
                          <tr>
                            <th className="text-capitalize align-middle text-center border-1 border " >Account Type</th>
                            <th className="text-capitalize align-middle text-center border-1 border " >Account Name</th>
                            <th className="text-capitalize align-middle text-center border-1 border " >Amount</th>
                          </tr>       
                        </thead>
                        <tbody className="align-middle sm-text"> 
                        {
                          reportData && reportData[0] && Object.keys(reportData[0]).map((group)=>{
                            let asset = 0;
                            return(
                              <>
                                <tr>
                                  <th className="text-capitalize align-middle text-center border-1 border">{group}</th>
                                  <td colSpan={2} className="text-center border-1 border"></td>
                                </tr>
                                {
                                  reportData[0][group] && reportData[0][group].map((item, index) => {
                                    assetsTotal += Number(item?.balance) || 0;
                                    asset += Number(item?.balance) || 0;
                                    return (
                                      <tr key={index}>
                                        <td className="text-capitalize align-middle text-center border-1 border "></td>
                                        <td className="text-capitalize align-middle text-center border-1 border ">{item?.AccountName || ''}</td>
                                        <td className="text-capitalize align-middle text-center border-1 border ">{item?.balance < 0 ? `(${formatPrice(item?.balance * -1)})` : (formatPrice(item?.balance) || '')}</td>
                                      </tr>
                                    )
                                  })
                                }
                                <tr>
                                  <td className="text-center border-1 border"></td>
                                  <th className="text-capitalize align-middle text-center border-1 border">Total</th>
                                  <td className="text-center border-1 border">{asset < 0 ? `(${formatPrice(asset * -1)})` : formatPrice(asset)}</td>
                                </tr>
                              </>
                            )
                          })
                        }
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border " colSpan={2}>Assets Total</th>
                          <td className="text-capitalize align-middle text-center border-1 border ">{assetsTotal < 0 ? `(${formatPrice(assetsTotal * -1)})` : formatPrice(assetsTotal)}</td>
                        </tr>
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border " colSpan={3}></th>
                        </tr>
                        {
                          reportData && reportData[1] && Object.keys(reportData[1]).map((group)=>{
                            let liability = 0;
                            return(
                              <>
                                <tr>
                                  <th className="text-capitalize align-middle text-center border-1 border">{group}</th>
                                  <td colSpan={2} className="text-center border-1 border"></td>
                                </tr>
                                {
                                  reportData[1][group] && reportData[1][group].map((item, index) => {
                                    liabilitiesTotal += Number(item?.balance) || 0;
                                    liability += Number(item?.balance) || 0;
                                    return (
                                      <tr key={index}>
                                        <td className="text-capitalize align-middle text-center border-1 border "></td>
                                        <td className="text-capitalize align-middle text-center border-1 border ">{item?.AccountName || ''}</td>
                                        <td className="text-capitalize align-middle text-center border-1 border ">{item?.balance < 0 ? `(${formatPrice(item?.balance * -1)})` : (formatPrice(item?.balance) || '')}</td>
                                      </tr>
                                    )
                                  })
                                }
                                <tr>
                                  <td className="text-center border-1 border"></td>
                                  <th className="text-capitalize align-middle text-center border-1 border">Total</th>
                                  <td className="text-center border-1 border">{liability < 0 ? `(${formatPrice(liability * -1)})` : formatPrice(liability)}</td>
                                </tr>
                              </>
                            )
                          })
                        }
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border " colSpan={2}>liabilities & Equity Total</th>
                          <td className="text-capitalize align-middle text-center border-1 border ">{liabilitiesTotal < 0 ? `(${formatPrice(liabilitiesTotal * -1)})` : formatPrice(liabilitiesTotal)}</td>
                        </tr>
                        {/* {reportData && reportData[0] &&
                          Array.from({ length: Math.max(reportData[0]?.length || 0, reportData[1]?.length || 0) }).map((_, index) => {
                            const itemA = reportData?.[0]?.[index];
                            const itemB = reportData?.[1]?.[index];
                            assetsTotal += Number(itemA?.balance) || 0;
                            liabilitiesTotal += Number(itemB?.balance) || 0;
                            return(
                              <tr>
                                {
                                  itemA && (
                                    <>
                                      <td className="text-capitalize align-middle text-center border-1 border ">{itemA ? index + 1 : ''}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border ">{itemA?.AccountName || ''}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border ">{itemA?.balance < 0 ? `(${itemA?.balance * -1})` : itemA?.balance || ''}</td>
                                    </>
                                  )
                                }
                                {
                                  itemB && (
                                    <>
                                      <td className="text-capitalize align-middle text-center border-1 border ">{itemB ? index + 1 : ''}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border ">{itemB?.AccountName || ''}</td>
                                      <td className="text-capitalize align-middle text-center border-1 border ">{itemB?.balance < 0 ? `(${itemB?.balance * -1})` : itemB?.balance || ''}</td>
                                    </>
                                  )
                                }
                              </tr>
                            )}
                          )
                        }
                        <tr>
                          <th className="text-capitalize align-middle text-center border-1 border " colSpan={2}>Assets Total</th>
                          <th className="text-capitalize align-middle text-center border-1 border ">{assetsTotal < 0 ? `(${assetsTotal * -1})` : assetsTotal}</th>
                          <th className="text-capitalize align-middle text-center border-1 border " colSpan={2}>Liabilities Total</th>
                          <th className="text-capitalize align-middle text-center border-1 border ">{liabilitiesTotal < 0 ? `(${liabilitiesTotal * -1})` : liabilitiesTotal}</th>
                        </tr>                           */}
                        </tbody>
                      </table>
                    )}
                  </div> 
                </div> 
              </div> 
            </div>           
          }
        </div> 
      </div> 

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <AccountsSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading}/>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {/* {loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="fragment-3">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t("Balance Sheet Report"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7 d-flex justify-content-end">
                            <div className="d-inline mr-3 d-flex align-items-center">
                              <div className="d-inline mr-2 d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input pointer-cursor"
                                  id="print_report"
                                  name="print_report"
                                  value="print"
                                  onChange={(e) => {
                                    handleOption(e);
                                  }}
                                  checked={
                                    option === "print"
                                  }
                                />
                                <label
                                  className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                  htmlFor="print_report"
                                  style={{fontSize:"16px",borderRadius:"5px"}}
                                >
                                  <i class="fa fa-print" aria-hidden="true"></i> {_t(t("Print"))}
                                </label>
                              </div>
                            </div>
                            <div className="d-inline mr-3 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="excel_report"
                                name="excel_report"
                                value="excel"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={
                                  option === "excel"
                                }
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="excel_report"
                                style={{fontSize:"16px",borderRadius:"5px"}}
                              >
                                <i class="fa fa-table" aria-hidden="true"></i> {_t(t("Excel"))}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="card px-2 mx-1">
                          {/* Form starts here */}
                          <form
                            className="row p-1 mx-0 mb-5 table-text"
                            onSubmit={handleSubmit}
                          >
                            <div className="col-12">
                              <div>                            
                                <div className="row">
                                  {/* <div className="form-group col-3 text-right mt-2">
                                    <div className="mb-2 text-left">
                                      <label
                                        htmlFor="fromDate"
                                        className="control-label"
                                      >
                                        {_t(t("From Date"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="mb-2">
                                      <DatePicker
                                        selected={reportFields.from_date}
                                        onChange={(date) => handleFromDate(date)}
                                        maxDate={new Date()}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        className="form-control table-text"
                                        placeholderText={_t(t("From Date"))}
                                        shouldCloseOnSelect={false}                                  
                                      />
                                    </div>
                                  </div> */}

                                  <div className="form-group col-3 text-right mt-2">
                                    <div className="mb-2 text-left">
                                      <label
                                        htmlFor="toDate"
                                        className="control-label"
                                      >
                                        {_t(t("Date"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <DatePicker
                                      selected={reportFields.to_date}
                                      onChange={(date) => handleToDate(date)}
                                      maxDate={new Date()}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text d-block"
                                      placeholderText={_t(t("Date"))}
                                      shouldCloseOnSelect={false}                                  
                                    />
                                  </div>

                                  <div className="form-group mt-2 col-3">
                                    <div className="mb-2 text-left">
                                      <label
                                        htmlFor="transaction"
                                        className="control-label"
                                      >
                                        {_t(t("Branch"))}                                  
                                      </label>
                                    </div>
                                    <Select
                                      options={branchForSearch ? branchForSearch : []}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={reportFields.branch || ""}
                                      classNamePrefix="select table-text"
                                      onChange={(branch)=>handleBranch(branch)} 
                                      isClearable                               
                                      placeholder={
                                        _t(t("Please select branch")) + ".."
                                      }
                                      styles={customStyle}
                                    />
                                  </div>

                                  <div className="form-group mt-2 col-4">
                                  </div>
                                
                                  <div className="form-group mt-4 col-2">                                                                                                                        
                                    <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded mt-2"
                                    >
                                      <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Print Sheet"))}
                                    </button>                                                                                                                                                                                       
                                  </div>
                                </div>
                              </div>                                                                        
                            </div>
                          </form>

                          {/** report view */}
                          {
                            balanceSheetView?.data || (searchBalanceSheetView?.list && searchBalanceSheetView.list.length) ? (
                              <div className="row">
                                <div className="col-12 mb-1 mx-2">
                                  {/* <div className="d-flex justify-content-end mb-2">
                                    <div className="form-file">
                                      <input
                                        type="text"
                                        className="form-control border-0 form-control--light-1 table-text rounded-sm"
                                        placeholder={_t(t("Search")) + ".."}
                                        onChange={handleSearch}
                                      />
                                    </div>
                                  </div> */}
                                  <div className="row gx-2 justify-content-center py-2 report  border border-1 rounded-sm">
                                    <div className="col-12 t-mb-15 mb-md-0 table-responsive" style={{height: "16rem"}} data-simplebar>
                                      <table
                                        className="table table-bordered table-hover min-table-height mt-3"
                                      >
                                        <thead className="align-middle">
                                          <tr>
                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                            {_t(t("Code"))}
                                            </th>
                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                              {_t(t("S/L"))}
                                            </th>
                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                              {_t(t("Doc Date"))}
                                            </th>
                                            
                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                              {_t(t("Doc No"))}
                                            </th>
                                            
                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                              {_t(t("Cheque No"))}
                                            </th>

                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                              {_t(t("Remarks"))}
                                            </th>
                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                              {_t(t("Debit"))}
                                            </th>
                                          
                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                              {_t(t("Credit"))}
                                            </th>

                                            <th
                                              scope="col"
                                              className="sm-text text-capitalize align-middle text-center border-1 border"
                                            >
                                              {_t(t("Balance"))}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="align-middle">
                                          {/* loop here*/}
                                          {balanceSheetView?.data && !searchBalanceSheetView.searched ? (balanceSheetView.data?.length ? (balanceSheetView.data.map((item, index) => {
                                              return (
                                                <tr key={index}>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center "
                                                  >
                                                    {index +
                                                    1 +
                                                    (balanceSheetView.current_page -
                                                      1) *
                                                      balanceSheetView.per_page}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                  <Moment format="LL">

                                                    {item.document_date}
                                                    </Moment>
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.branch_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.unit_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.stock_qty}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.avg_rate)}
                                                  </td>
                                                
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.amount)}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )) : (
                                            <tr>
                                              <td colSpan={9} className="xsm-text text-capitalize align-middle text-center">
                                                {_t(t("No data available"))}
                                              </td>
                                            </tr>
                                          )) : (
                                            searchBalanceSheetView?.list && searchBalanceSheetView.list?.length ?
                                            searchBalanceSheetView.list.map((item,index)=>{
                                              return (
                                                <tr key={index}>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center "
                                                  >
                                                    {index +
                                                    1 +
                                                    (balanceSheetView.current_page -
                                                      1) *
                                                      balanceSheetView.per_page}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                  <Moment format="LL">

                                                    {item.document_date}
                                                    </Moment>
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.branch_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.unit_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {item.stock_qty}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.avg_rate)}
                                                  </td>
                                                
                                                  <td
                                                    scope="row"
                                                    className="xsm-text text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.amount)}
                                                  </td>
                                                </tr>
                                              );
                                            }) : (
                                              <tr>
                                                <td colSpan={9} className="xsm-text text-capitalize align-middle text-center">
                                                  {_t(t("No data available"))}
                                                </td>
                                              </tr>
                                            )
                                          )
                                        }
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : ""
                          }
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  )
}

export default BalanceSheetReport;
